import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { 
  Scale, 
  BarChart3,
  FileText, 
  Search, 
  FileCheck, 
  File, 
  BookOpen, 
  Shield, 
  Gavel, 
  PenTool, 
  Calculator,
  List,
  MessageCircle,
  Settings,
  LogOut,
  User
} from 'lucide-react';

const Sidebar = ({ user, onLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  const menuItems = [
    { path: '/dashboard', icon: BarChart3, label: 'Overview' },
    { path: '/dashboard/legal-guidance', icon: MessageCircle, label: 'Legal Guidance' },
    { path: '/dashboard/tools', icon: FileText, label: 'AI Tools' },
    { path: '/dashboard/legal-research', icon: Search, label: 'Legal Research' },
    { path: '/dashboard/case-summary', icon: FileCheck, label: 'Case Summary' },
    { path: '/dashboard/contract-review', icon: File, label: 'Contract Review' },
    { path: '/dashboard/legal-brief', icon: BookOpen, label: 'Legal Brief' },
    { path: '/dashboard/compliance', icon: Shield, label: 'Compliance' },
    { path: '/dashboard/precedents', icon: Gavel, label: 'Precedents' },
    { path: '/dashboard/document-draft', icon: PenTool, label: 'Document Draft' },
    { path: '/dashboard/cost-estimate', icon: Calculator, label: 'Cost Estimate' },
    { path: '/dashboard/worklist', icon: List, label: 'Worklist' }
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <Scale size={24} />
        <h1>S5 Kaizen Legal</h1>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path || 
            (item.path === '/dashboard' && location.pathname === '/dashboard') ||
            (item.path !== '/dashboard' && location.pathname.startsWith(item.path));
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${isActive ? 'active' : ''}`}
            >
              <Icon size={18} />
              {item.label}
            </Link>
          );
        })}
      </nav>

      <div style={{ marginTop: 'auto', padding: '16px', borderTop: '1px solid #334155' }}>
        <div className="nav-item" style={{ opacity: 0.7, cursor: 'default' }}>
          <User size={18} />
          {user?.name || 'User'}
        </div>
        <Link
          to="/dashboard/settings"
          className={`nav-item ${location.pathname === '/dashboard/settings' ? 'active' : ''}`}
        >
          <Settings size={18} />
          Settings
        </Link>
        <button
          onClick={handleLogout}
          className="nav-item"
          style={{ color: '#ef4444' }}
        >
          <LogOut size={18} />
          Sign Out
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
